// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 609 ? "faq" : chunkId) + "-legacy." + {"241":"2b77eef1","532":"33fc5741","609":"a74db22e"}[chunkId] + ".js";
};